import React, {useState, useEffect}  from 'react';
import * as ServerComms from '../utilities/ServerComms';
import ImageGrid from '../ImageGrid';

function App(props) {

  var entityName = props.entityName;
  var width = props.width;
  var nos = props.nos;
  var currentImageUrl = props.currentImageUrl;
  var signKey = props.signKey;
  var userID = props.userID;
  var sessionID = props.sessionID;
  var addWhereText = props.addWhereText;
  var clickImage = props.clickImage;

  const [images, setImages] = useState([]);
  const [haveLoaded,setHaveLoaded] = useState(false);
  const [currentValue, setCurrentValue] = useState("");
  const [imageSelected, setImageSelected] = useState(false);
  const [imageLoadError, setImageLoadError] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(false);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [uploadedWidth, setUploadedWidth] = useState(0);
  const [uploadedHeight, setUploadedHeight] = useState(0);


  function refreshImages(){
    function postGetImages(response){
      if (response.t === 'list'){
        setImages(response.v);
        setHaveLoaded(true);        
      }
    }
    ServerComms.fetchSomething({u:'getImages', entityName, signKey, userID, sessionID}, postGetImages);
  }
  useEffect(() => {
    refreshImages();
   }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function changeValue(e){
    setCurrentValue(e.target.value)
  }
  var entityText;
  var longEntityText;
  if (entityName === 'IMG'){
    entityText = 'image';
    longEntityText = 'an image';
  }else if (entityName === 'VIDEO'){
    entityText = 'video';
    longEntityText = 'a video';
  }

  var txt = '';
  if (addWhereText){
    txt = 'Add ' + entityText + ' to ' + addWhereText + '. ';
  }
  if (images.length > 0){
    txt += 'Enter your ' + entityText + ' url, upload ' + longEntityText + ', or select from the library below';
  }else{
    txt += 'Enter your ' + entityText + ' url, or upload ' + longEntityText;
  }
//
  if (imageLoadError){
    txt = 'Invalid Url. Please try again';
  }

  function onKeyDown(e){
    if (e.keyCode === 13){
      setImageLoadError(false);
      setImageSelected(true);
    }
  }

  var loadPiece;
  if (uploadedImage){

    function submitNewImage(){
      function postUploadImage(response){
        if (clickImage){
          clickImage(response.v, uploadedWidth, uploadedHeight);
        }
        setUploadedImage(null);
        setIsDoingSomething(false);
        refreshImages();
      }

      function failFunction(response){
        setIsDoingSomething(false);
        console.log(response);
      }
      setIsDoingSomething('uploading');
      ServerComms.fetchSomething({u:'submitNewImage', entityName, signKey, userID, sessionID, uploadedWidth, uploadedHeight}, postUploadImage, failFunction, [uploadedImage]);
    }

      var submitButton;
      var removeButton;
      var space;
      if (isDoingSomething === 'uploading'){
        submitButton = <div>Uploading...</div>
//
      }else{
        removeButton = <button className='btn btn-primary' onClick={()=>setUploadedImage(null)}>Remove</button>
        space = <span>&nbsp;&nbsp;&nbsp;</span>
        submitButton = <button className='btn btn-primary' onClick={submitNewImage}>Submit</button>
//
      }

      var src = URL.createObjectURL(uploadedImage);
    return <div><center>
        <br/>
        <img alt="not found" style={{width:width - 20}} src={src} />
        <br /><br/>
        {submitButton}{space}{removeButton}
        </center>
        </div>
//
  }else if (imageSelected){ //this is upload via url.

    function handleImageLoaded() {

      var img = new Image();
      img.onload = function () {
        setUploadedWidth(this.width);
        setUploadedHeight(this.height);
      };
      img.src = currentValue;
      setImageLoadError(false);
    }


    function handleImageErrored() {
      setImageLoadError(true);
      setImageSelected(false);
    }

//
    function clickConfirm(e){
      ServerComms.fetchSomething({u:"addImageUrl", value:currentValue, signKey, userID, sessionID, entityName, uploadedWidth, uploadedHeight}, refreshImages);
      if (clickImage){
        clickImage(currentValue, uploadedWidth, uploadedHeight);
      }
      // refreshImages();
    }
    function clickCancel(e){
      setImageSelected(false);
    }

      return <div><center>
            <br/>
            <img alt="" onLoad={handleImageLoaded} onError={handleImageErrored} src={currentValue} style={{width:width-20}} />
            <br/><br/>
            <button className='btn btn-primary' onClick={clickConfirm}>Select</button><span>&nbsp;&nbsp;&nbsp;</span>
            <button className='btn btn-primary' onClick={clickCancel}>Cancel</button>
            </center>
      </div>
//      
  }else if (haveLoaded){  
    function clickDelete(imageID){
      return function(e){
        var p = window.confirm("Please confirm that you'll like to delete this " + entityText);
        if (p){
          ServerComms.fetchSomething({u:"deleteImage", imageID, signKey, userID, sessionID, entityName}, refreshImages);
        }
        e.stopPropagation();
      }
    }
    loadPiece = <ImageGrid clickImage={clickImage} width={width} nos={nos} currentImageUrl={currentImageUrl} filteredImages={images} clickDelete={clickDelete}/>

  }else{
    loadPiece = <div>Loading...</div>
  }

//

        

//accept="video/*" as alternative in future. haha but file very big leh.
        // accept="image/*"

  //      
  return (<div style={{textAlign:"center"}}>
      <center><br/>
      <input autoComplete="none" autoFocus type="text" className="inputBoxClass" placeholder="URL" value={currentValue} onChange={changeValue} onKeyDown={onKeyDown}/>
      <br/><br/>
      <input
        type="file"
        name='myImage1'
        onChange={(event) => {
          var file = event.target.files[0];
          if(file.size > 1048576){
             alert("File is too big! Maximum of 1mb");
             return;
          };          

          var img = new Image();
          var objectUrl = URL.createObjectURL(file);
          img.onload = function () {
            setUploadedWidth(this.width);
            setUploadedHeight(this.height);
            URL.revokeObjectURL(objectUrl);
          };
          img.src = objectUrl;

          setUploadedImage(file);
        }}
      />
      <br/><br/>
      <p className="lead mb-0 px-2">{txt}</p><br/>
    {loadPiece}
    </center></div>)
//
}


export default App;
